var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-show-body-form-group flex flex-col"},_vm._l((_vm.formRecords),function(formRecord){return _c('operation-report-show-body-form',_vm._b({key:formRecord.operationWorkflowForm.id,attrs:{"reportId":_vm.reportId}},'operation-report-show-body-form',formRecord,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }